import { AxiosInstanceProvider } from '../../../core/hooks';
import { ItsmNetworkServiceIncidentApiModel } from '../../../itsm/model';
import { DashboardHttpQueryConfig } from '../../config';

export interface DashboardItsmNetworkServiceIncidentsHttpGetPayloadModel {
  customerId: number;
}

export type DashboardItsmNetworkServiceIncidentsHttpGetResponseModel = ItsmNetworkServiceIncidentApiModel[];

export const getDashboardItsmNetworkServiceIncidents = async (
  axios: AxiosInstanceProvider,
  { customerId }: DashboardItsmNetworkServiceIncidentsHttpGetPayloadModel
): Promise<DashboardItsmNetworkServiceIncidentsHttpGetResponseModel> => {
  const response = await axios().get<DashboardItsmNetworkServiceIncidentsHttpGetResponseModel>(
    DashboardHttpQueryConfig['GetItsmNetworkServiceIncidents'].url.replace('{customerId}', customerId.toString(10)));
  return response.data;
};